module.exports = __webpack_public_path__ + "static/img/example1.836d13f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example1.jpg
// module id = 1iGu
// module chunks = 128